import React, { useState } from "react";
import '../Contact/Contact.css';

const HomeContact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    interest: "",
    comment: ""
  });

  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus("");

    const data = {
      access_key: "33758703-84b6-45b7-b677-a2d8023e3622",
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      interest: formData.interest,
      message: formData.comment,
      subject: "New Property Enquiry",
      from_name: "Saptveda venture",
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      });

      const result = await response.json();

      if (result.success) {
        setStatus("Form is submitted successfully ✅");
        setFormData({
          name: "",
          email: "",
          phone: "",
          interest: "",
          comment: ""
        });
          setTimeout(() => {
          setStatus("");
        }, 5000);
      } else {
        setStatus("Submission failed ❌ Please try again.");
      }
    } catch (error) {
      setStatus("Network error ❌ Please try again.");
    }

    setLoading(false);
  };

  return (
    <section className="home-contact">
      <div className="contact-border">
        <div className="contact-wrapper">
          <h2 className="contact-title">CONNECT WITH US</h2>
          <p className="contact-subtitle">PLEASE FILL YOUR DETAILS BELOW</p>

          <form className="contact-form" onSubmit={handleSubmit}>

            <div className="form-row">
              <input 
                type="text" 
                name="name"
                placeholder="Name*" 
                value={formData.name}
                onChange={handleChange}
                required 
              />

              <input 
                type="email" 
                name="email"
                placeholder="Email*" 
                value={formData.email}
                onChange={handleChange}
                required 
              />
            </div>

            <div className="form-row">
              <div className="mobile-field">
                <input 
                  type="tel" 
                  name="phone"
                  placeholder="Mobile*" 
                  value={formData.phone}
                  onChange={handleChange}
                  required 
                />
              </div>

              <select 
                name="interest"
                value={formData.interest}
                onChange={handleChange}
                required
              >
                <option value="">Select your Interest</option>
                <option value="Plots">Plots</option>
                <option value="FarmHouse">FarmHouse</option>
                <option value="Shops">Shops</option>
                <option value="Office space">Office space</option>
                <option value="Flats">Flats</option>
                <option value="Others">Others</option>
              </select>
            </div>

            <textarea 
              name="comment"
              placeholder="Comment*" 
              rows="4" 
              value={formData.comment}
              onChange={handleChange}
              required 
            />

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? "Submitting..." : "SUBMIT"}
            </button>

            {/* Status Message */}
            {status && <p className="form-status">{status}</p>}

          </form>
        </div>
      </div>
    </section>
  );
};

export default HomeContact;
